module.exports = __webpack_public_path__ + "img/analytic.bfa802ac.svg";